import { useSelector } from "react-redux";

import { RootState } from "../../state/store";

// Note: whether this deployment has an FMS. Everything that exists only because of one - telemetry pages,
// provenance columns, checking and accepting inferred rows, grouping them - hides when this is false. Absent
// reads as off, so a mine with no FMS, or a client older than its server, never sees any of it.
export function useTelemetryEnabled(): boolean {
  return useSelector((state: RootState) => state.authReducer.roleConfig?.telemetryEnabled ?? false);
}
